import { render, staticRenderFns } from "./PersonaActivoDeuda.vue?vue&type=template&id=d8b6a5de"
import script from "./PersonaActivoDeuda.js?vue&type=script&lang=js&external"
export * from "./PersonaActivoDeuda.js?vue&type=script&lang=js&external"
import style0 from "./PersonaActivoDeuda.vue?vue&type=style&index=0&id=d8b6a5de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports